/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type infoChangeContainerPhysicalStatusInput = {
    clientMutationId?: string | null;
    slug: string;
    physicalStatus: string;
    changeDate?: string | null;
    containerInstance?: any | null;
};
export type ContainerLocationChangeStatusMutationVariables = {
    input: infoChangeContainerPhysicalStatusInput;
};
export type ContainerLocationChangeStatusMutationResponse = {
    readonly infoChangeContainerPhysicalStatus: {
        readonly container: {
            readonly " $fragmentRefs": FragmentRefs<"ContainerLocation_container">;
        };
    } | null;
};
export type ContainerLocationChangeStatusMutation = {
    readonly response: ContainerLocationChangeStatusMutationResponse;
    readonly variables: ContainerLocationChangeStatusMutationVariables;
};



/*
mutation ContainerLocationChangeStatusMutation(
  $input: infoChangeContainerPhysicalStatusInput!
) {
  infoChangeContainerPhysicalStatus(input: $input) {
    container {
      ...ContainerLocation_container
      id
    }
  }
}

fragment ContainerLocation_container on Container {
  slug
  physicalStatus
  dischargeDate
  terminalDate
  warehouseInDate
  validPhysicalStatuses {
    value
    title
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ContainerLocationChangeStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoChangeContainerPhysicalStatusPayload",
        "kind": "LinkedField",
        "name": "infoChangeContainerPhysicalStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Container",
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ContainerLocation_container"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "ApplicationCommand",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ContainerLocationChangeStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "infoChangeContainerPhysicalStatusPayload",
        "kind": "LinkedField",
        "name": "infoChangeContainerPhysicalStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Container",
            "kind": "LinkedField",
            "name": "container",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "slug",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "physicalStatus",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "dischargeDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "terminalDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "warehouseInDate",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "ValidPhysicalStatus",
                "kind": "LinkedField",
                "name": "validPhysicalStatuses",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "value",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d3585d43f9aad479ac6746eaeff0865d",
    "id": null,
    "metadata": {},
    "name": "ContainerLocationChangeStatusMutation",
    "operationKind": "mutation",
    "text": "mutation ContainerLocationChangeStatusMutation(\n  $input: infoChangeContainerPhysicalStatusInput!\n) {\n  infoChangeContainerPhysicalStatus(input: $input) {\n    container {\n      ...ContainerLocation_container\n      id\n    }\n  }\n}\n\nfragment ContainerLocation_container on Container {\n  slug\n  physicalStatus\n  dischargeDate\n  terminalDate\n  warehouseInDate\n  validPhysicalStatuses {\n    value\n    title\n  }\n}\n"
  }
};
})();
(node as any).hash = 'b1a8001fc4dae4369407a556629f6efa';
export default node;
